export const openTakeawayRazorpay = ({ gateway, restaurantName, order, onSuccess, onDismiss, onFailure }) => {
  if (!window.Razorpay) throw new Error("Online payment is still loading. Please try again.");
  const checkout = new window.Razorpay({
    key: gateway.keyId,
    order_id: gateway.providerOrderId,
    amount: gateway.amountInPaise,
    currency: gateway.currency,
    name: restaurantName,
    description: `Takeaway ${order.tokenNumber}`,
    prefill: { name: order.customerName || "", contact: order.customerPhone || "" },
    theme: { color: "#fb6236" },
    handler: onSuccess,
    modal: { ondismiss: onDismiss },
  });
  checkout.on("payment.failed", onFailure);
  checkout.open();
};
